





export default {
  name: 'BaseLoader'
};
